//@ts-nocheck
import { useEffect, useRef} from "react";
import { fieldType } from "../../../../types/form";
import { RichTextarea, createRegexRenderer } from "rich-textarea";
import { PaperClipIcon } from "@heroicons/react/24/outline";

type Props = {
  dataField: fieldType;
  onChange: (data: any) => void;
  errors?: any;
  value: any;
  minHeight?: number;
  disabled?: boolean;
  showAttachIcon?: boolean;
  attachActive?: boolean;
  onAttachClick?: () => void;
};

const renderer = createRegexRenderer([[/(^|\W)(#[а-я\w][а-я\w-]*)/gi, { color: "rgb(0,98,155)" }]]);

const DEFAULT_MIN_HEIGHT = 150;

function TextAreaVPO(props: Props) {
  const {
    dataField,
    onChange,
    errors,
    value,
    minHeight = DEFAULT_MIN_HEIGHT,
    disabled = false,
    showAttachIcon = false,
    attachActive = false,
    onAttachClick,
  } = props;
  const editor = useRef();

  useEffect(() => {
    editor.current.style.height = "inherit";
    editor.current.style.height = `${Math.max(editor.current.scrollHeight, minHeight)}px`;
  }, [value, minHeight]);

  return (
    <div className={`${dataField.width} text-black`}>
      <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
        <span>{dataField.title}</span>
        {dataField.require && (
          <div className="flex flex-row justify-between">
            {Object.keys(errors).length > 0 && errors[dataField.key] && <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>}
            <span className="text-[#BA0C2F]">*</span>
          </div>
        )}
      </label>
      <div className="mt-2 rich-text-area relative">
        <RichTextarea
          className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]`}
          style={{
            minHeight: minHeight,
            resize: "none",
            width: "100%",
            overflow: "hidden",
            paddingRight: showAttachIcon ? 44 : undefined,
          }}
          ref={editor}
          disabled={disabled || dataField.disabled}
          value={value}
          placeholder={dataField.placeholder}
          onChange={e => onChange(e.target.value)}
        >
          {renderer}
        </RichTextarea>
        {showAttachIcon && (
          <button
            type="button"
            onClick={onAttachClick}
            disabled={disabled || dataField.disabled}
            title="Прикрепить файлы"
            className={`absolute bottom-2 right-2 p-1.5 rounded transition-colors disabled:cursor-not-allowed disabled:text-[#8899A8] disabled:hover:bg-transparent ${attachActive ? 'text-blue-700 bg-blue-50' : 'text-[#637381] hover:bg-gray-100'}`}
          >
            <PaperClipIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
}

export default TextAreaVPO;
